import { useRequestURL } from '#imports'

import { getSheerIdLocaleParam } from '../../utils/sheerIdLocale'

function buildSheerIdURl({
  baseSheerIdUrl,
  bmUserId,
  locale,
}: {
  baseSheerIdUrl: string
  bmUserId: string
  locale: string
}) {
  const url = new URL(baseSheerIdUrl)
  url.searchParams.append('locale', getSheerIdLocaleParam(locale))
  url.searchParams.append('userid', bmUserId)

  return url.href
}

export function buildMilitaryDiscountUrl({
  authenticated,
  baseSheerIdUrl,
  bmUserId = 'USER_ID',
  locale,
}: {
  baseSheerIdUrl: string
  authenticated: boolean
  bmUserId?: string
  locale: string
}) {
  const baseUrl = useRequestURL().origin
  const sheerIdUrl = buildSheerIdURl({
    baseSheerIdUrl,
    bmUserId,
    locale,
  })

  if (authenticated) return sheerIdUrl

  try {
    const redirectionUrl = new URL(`${baseUrl}/${locale}/auth/login`)
    redirectionUrl.searchParams.append('next', sheerIdUrl)
    redirectionUrl.searchParams.append('type', 'external')
    redirectionUrl.searchParams.append('bm_journey', 'military_discount')

    return redirectionUrl.href
  } catch (err) {
    const invalidUrlError = new Error(
      `"${baseUrl}/${locale}/auth/login" is an invalid URL.`,
    )
    if (err instanceof Error) invalidUrlError.stack = err.stack
    throw invalidUrlError
  }
}
